import { Config } from 'ha/config';
import { FetchClient } from 'ha/helpers/FetchClient';
import { Language } from '@ha/intl';

import { apiV2 as createApiV2 } from '@ha/api/v2/api-v2';
import { createTranslationService } from './Translation';
import { createFBService as makeFBService } from './facebook';
import { GoogleMapApi as googleMapApi } from './GoogleMapApi';
import { analytics as makeAnalyticsService } from './analytics';
import { createAlgoliaService as algoliaService } from './algolia';
import { twilio as makeTwilioService } from './twilio';
import { createOsiris as makeOsirisService } from './osiris';
import { makeHermesService } from './hermes';
import { makeAlmanacService } from './almanac';
import { makeMetisService } from './metis';
import { makeBellService } from './bell';
import { CookieClient, makeCookieService } from './cookie';

import { SplitIOClient as SplitIO } from './SplitIO';

interface Clients {
  haApi: FetchClient;
  osiris: FetchClient;
  hermes: FetchClient;
  almanac: FetchClient;
  metis: FetchClient;
  bell: FetchClient;
  splitio: SplitIO;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  algolia: ReturnType<typeof algoliaService>;
  cookie: CookieClient;
}
interface AppServicesSetup {
  config: Config;
  clients: Clients;
  lang: Language;
}

export function getAppServices({ config, clients, lang }: AppServicesSetup) {
  return {
    translation: createTranslationService(
      {
        languageDetectionURL: config.languageDetectionURL,
      },
      clients.haApi,
    ),
    algolia: clients.algolia,
    facebook: makeFBService({
      clientId: config.facebook.client_id,
      clientToken: config.facebookClientToken,
    }),
    googleMapApi: googleMapApi({ key: config.google.maps_key, language: lang }),
    apiV2: createApiV2(clients.haApi),
    hermes: makeHermesService(clients.hermes),
    almanac: makeAlmanacService(clients.almanac),
    metis: makeMetisService(clients.metis),
    osiris: makeOsirisService(clients.osiris),
    bell: makeBellService(clients.bell),
    cookie: makeCookieService(clients.cookie),
    analytics: makeAnalyticsService(config.analytics),
    twilio: makeTwilioService(),
    splitio: clients.splitio,
  };
}

export type AppServices = ReturnType<typeof getAppServices>;
